<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_29142_284596)">
      <path
        d="M12.7411 5.68952C12.7411 4.41626 12.2416 3.19514 11.3525 2.29481C10.4635 1.39447 9.25764 0.888672 8.00032 0.888672C6.74299 0.888672 5.53717 1.39447 4.64811 2.29481C3.75904 3.19514 3.25957 4.41626 3.25957 5.68952C3.25957 11.2905 0.88916 12.4442 0.88916 12.4442H15.1114C15.1114 12.4442 12.7411 11.2905 12.7411 5.68952Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.77783 12.8887C5.77783 13.5998 6.07413 14.0739 6.22228 14.222C6.40294 14.4924 6.66226 14.7168 6.97426 14.8728C7.28626 15.0288 7.64 15.1109 8.00005 15.1109C8.36011 15.1109 8.71385 15.0288 9.02585 14.8728C9.33785 14.7168 9.59717 14.4924 9.77783 14.222C9.92598 14.0739 10.2223 13.5998 10.2223 12.8887"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29142_284596">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
</script>
